import React from 'react';

/**
 * Simple reusable Button component with variants.
 */
function Button({
  onClick,
  children,
  className = '',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  title,
  type = 'button',
  'aria-label': ariaLabel
}) {
  const baseStyle = 'rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-out';

  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 disabled:bg-blue-300',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400 disabled:bg-gray-100',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 disabled:bg-red-300',
    ghost: 'bg-transparent text-gray-600 hover:bg-gray-100 hover:text-gray-800 focus:ring-gray-400 disabled:text-gray-400 disabled:hover:bg-transparent',
  };

  const sizes = {
    sm: 'px-2 py-1 text-sm',
    medium: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyle} ${sizes[size]} ${variants[variant]} ${className}`}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

export default Button;
